import React from "react";


const Home = () => {

 

  return (
    
    <main className="fpx">
      <div className="container content has-text-centered">
        



        
        <div className="fp">


        


          <div className="brand brand-wcm">
            <a href="https://www.wisden.com">
              <div className="brand-name">Wisden Cricket Monthly</div>
              <div className="brand-strap">The independent voice of cricket. Expert opinion. Quality journalism.</div>

              <div className="content-wrap">
                <div className="content-left"><img src={`${process.env.PUBLIC_URL}/wcm-spread-1.jpg`} alt="A spread from Wisden Cricket Monthly" /></div>
                <div className="content-right"><img src={`${process.env.PUBLIC_URL}/wcm-spread-2.jpg`} alt="A spread from Wisden Cricket Monthly" /></div>

                <div className="cover-mask">
                  <div className="cover"><img src={`${process.env.PUBLIC_URL}/wcm-cover-77.jpg`} alt="The cover of Wisden Cricket Monthly" /></div>
                </div>
              </div>
            </a>
          </div>




          <div className="brand brand-bz">
            <a href="https://theblizzard.co.uk">
              <div className="brand-name light">The Blizzard</div>
              <div className="brand-strap light">Football writing for the thinking fan</div>

              <div className="content-wrap">
                <div className="content-left">
                  <img 
                    loading="lazy"
                    src={`${process.env.PUBLIC_URL}/bz-spread-53-142.jpg`}
                    srcset={`
                      ${process.env.PUBLIC_URL}/bz-spread-53-142.jpg 1x, 
                      ${process.env.PUBLIC_URL}/bz-spread-53-142@2x.jpg 2x
                      `}
                    alt="A spread from the Blizzard"/>
                </div>
                <div className="content-right">
                  <img 
                    loading="lazy"
                    src={`${process.env.PUBLIC_URL}/bz-spread-53-178.jpg`}
                    srcset={`
                      ${process.env.PUBLIC_URL}/bz-spread-53-178.jpg 1x, 
                      ${process.env.PUBLIC_URL}/bz-spread-53-178@2x.jpg 2x
                      `}
                    alt="A spread from the Blizzard"/>
                </div>

                <div className="cover-mask">
                  <div className="cover"><img src={`${process.env.PUBLIC_URL}/bz-cover-53.jpg`} alt="The cover of Blizzard 53"/></div>
                </div>
              </div>
            </a>
          </div>





          <div className="brand brand-fb">]
            <a href="https://fairfieldbooks.co.uk">
            <div className="brand-name light">Fairfield Books</div>
              <div className="brand-strap light">First-class cricket reading</div>

              <div className="content-wrap">

                <div className="cover-mask">

                  <div className="content-cover content-cover-1">
                    <img 
                      loading="lazy"
                      src={`${process.env.PUBLIC_URL}/ff-cover-queen.jpg`}
                      srcset={`
                        ${process.env.PUBLIC_URL}/ff-cover-queen.jpg 1x, 
                        ${process.env.PUBLIC_URL}/ff-cover-queen@2x.jpg 2x
                        `}
                      alt="The cover of The Queen at the Cricket"/>
                  </div>
                  <div className="content-cover content-cover-2">
                    <img 
                      loading="lazy"
                      src={`${process.env.PUBLIC_URL}/ff-cover-boycott.jpg`}
                      srcset={`
                        ${process.env.PUBLIC_URL}/ff-cover-boycott.jpg 1x, 
                        ${process.env.PUBLIC_URL}/ff-cover-boycott@2x.jpg 2x
                        `}
                      alt="The cover of Being Geoffrey Boycott"/>
                  </div>
                  <div className="content-cover content-cover-3">
                      <img 
                      loading="lazy"
                      src={`${process.env.PUBLIC_URL}/ff-cover-ellcock.jpg`}
                      srcset={`
                        ${process.env.PUBLIC_URL}/ff-cover-ellcock.jpg 1x, 
                        ${process.env.PUBLIC_URL}/ff-cover-ellcock@2x.jpg 2x
                        `}
                      alt="The cover fo Balls to Fly"/>
                  </div>
                  <div className="content-cover content-cover-4">
                      <img 
                      loading="lazy"
                      src={`${process.env.PUBLIC_URL}/ff-cover-worrell.jpg`}
                      srcset={`
                        ${process.env.PUBLIC_URL}/ff-cover-worrell.jpg 1x, 
                        ${process.env.PUBLIC_URL}/ff-cover-worrell@2x.jpg 2x
                        `}
                      alt="the cover of Son of Grace"/>
                  </div>

                  <div className="cover">
                    <img 
                    loading="lazy"
                    src={`${process.env.PUBLIC_URL}/ff-cover-wock.jpg`}
                    srcset={`
                      ${process.env.PUBLIC_URL}/ff-cover-wock.jpg 1x, 
                      ${process.env.PUBLIC_URL}/ff-cover-wock@2x.jpg 2x
                      `}
                    alt="The cover of Who Only Cricket know"/>
                  </div>
                </div>
              </div>
            </a>
          </div>



          

          <div className="brand brand-nwm">
            <a href="https://www.thenightwatchman.net">
              <div className="brand-name">The Nightwatchman</div>
              <div className="brand-strap">A collection of cricket essays and long-form articles</div>

              <div className="content-wrap">
                <div className="content-left">
                  <img 
                    loading="lazy"
                    src={`${process.env.PUBLIC_URL}/nwm-spread-46-104.jpg`}
                    srcset={`
                      ${process.env.PUBLIC_URL}/nwm-spread-46-104.jpg 1x, 
                      ${process.env.PUBLIC_URL}/nwm-spread-46-104@2x.jpg 2x
                      `}
                    alt="A spread from The Nightwatchman"/>
                </div>
                <div className="content-right">
                    <img 
                    loading="lazy"
                    src={`${process.env.PUBLIC_URL}/nwm-spread-46-94.jpg`}
                    srcset={`
                      ${process.env.PUBLIC_URL}/nwm-spread-46-94.jpg 1x, 
                      ${process.env.PUBLIC_URL}/nwm-spread-46-94@2x.jpg 2x
                      `}
                    alt="A spread from The Nightwatchman"/>
                </div>

                <div className="cover-mask">
                  <div className="cover">
                    <img 
                    loading="lazy"
                    src={`${process.env.PUBLIC_URL}/nwm-cover-46.jpg`}
                    srcset={`
                      ${process.env.PUBLIC_URL}/nwm-cover-46.jpg 1x, 
                      ${process.env.PUBLIC_URL}/nwm-cover-46@2x.jpg 2x
                      `}
                    alt="The cover of The Nightwatchman"/>
                  </div>
                </div>
              </div>
              </a>
          </div>
          


          


          <div className="brand brand-cww">
            <a href="https://fairfieldbooks.co.uk/shop/the-cricketers-whos-who-2025">
              <div className="brand-name">Cricketer's Who's Who</div>
              <div className="brand-strap">The essential guide to the cricket season</div>

              <div className="content-wrap">
                <div className="content-left">
                  <img 
                    loading="lazy"
                    src={`${process.env.PUBLIC_URL}/cww-spread-2024-588.jpg`}
                    srcset={`
                      ${process.env.PUBLIC_URL}/cww-spread-2024-588.jpg 1x, 
                      ${process.env.PUBLIC_URL}/cww-spread-2024-588@2x.jpg 2x
                      `}
                    alt="A spread from The Cricketer's Who's Who" />
                </div>
                <div className="content-right">
                    <img 
                    loading="lazy"
                    src={`${process.env.PUBLIC_URL}/cww-spread-2024-110.jpg`}
                    srcset={`
                      ${process.env.PUBLIC_URL}/cww-spread-2024-110.jpg 1x, 
                      ${process.env.PUBLIC_URL}/cww-spread-2024-110@2x.jpg 2x
                      `}
                    alt="A spread from The Cricketer's Who's Who"/>
                </div>

                <div className="cover-mask">
                  <div className="cover">
                    <img 
                    loading="lazy"
                    src={`${process.env.PUBLIC_URL}/cww-cover-2024.jpg`}
                    srcset={`
                      ${process.env.PUBLIC_URL}/cww-cover-2024.jpg 1x, 
                      ${process.env.PUBLIC_URL}/cww-cover-2024@2x.jpg 2x
                      `}
                    alt="The cover of The Cricketer's Who's Who"/>
                  </div>
                </div>
              </div>
            </a>
          </div>







        </div>
      </div>
    </main>

  );
}



export default Home;
